export default __webpack_public_path__ + "static/media/photo--sm--kara5.897a2a68.jpg";